/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Header3 from '../../components/header/header-rslhome'
import FooterRSL from '../../components/footer/footer-new'
import DynamicHero from '../../components/Investor/DynamicHero'
import Seo from '../../components/common/Seo'
import { useDispatch, useSelector } from 'react-redux'
import {
  getInvestorList,
  getFleetCar,
  getPartnerLogo,
  getBlogList
} from '../../redux/slices/common'
import BannerSlider from '../../components/Investor/BannerOne'
import AppDownloadSection from '../../components/AppDownloadSection/AppDownloadSection'
import EarnInYourLocation from '../../components/supplier/EarnInYourLocation'
import SupplierSlide from '../../components/SupplierAllSlide/SupplierSlide'
import Organizations from '../../components/all-services/organization'
import PartnerCarousel from '../../components/all-services/partnerCarouselComponent'
import VendorRegistrationFormSupplier from '../../components/all-services/vendorRegistrationFormSupplier'
import CommunicationChannel from '../../components/Investments/CommunicationChannel'
import { fetchSeoByPage } from '../../lib/seoHelper'

const Supplier = ({ meta }) => {
  const [currentTab, setCurrentTab] = useState('FLEET')
  const dispatch = useDispatch()
  const router = useRouter()
  const [loader, setLoader] = useState(true)
  const [equipmentTypeList, setEquipmentTypeList] = useState([])
  const { InvestorList, fleetState, partnerLogo, getBlogListSuccessRes } =
    useSelector(state => state.common)
  const [fleetLoader, setFleetLoader] = useState(true)

  const [fleetVideoAvailable, setFleetVideoAvailable] = useState(false)
  const [busVideoAvailable, setBusVideoAvailable] = useState(false)
  const [safariVideoAvailable, setSafariVideoAvailable] = useState(false)

  const [isVideoPlayingForBuses, setIsVideoPlayingForBuses] = useState(false)
  const [isVideoPlayingForSafari, setIsVideoPlayingForSafari] = useState(false)
  const [fleetCard, setFleetCard] = useState([])

  const [selectedCardId, setSelectedCardId] = useState(null)
  const [activeType, setActiveType] = useState('All')
  const [partnerCard, setPartnerCard] = useState([])
  const [imageLocal, setImageLocal] = useState([
    {
      link: '/images/userwebsite/b2b/banner.png',
      image: '/images/userwebsite/b2b/banner.png'
    }
  ])
  const [openEnquire, setOpenEnquire] = useState(false)
  const [blogList, setBlogList] = useState([])

  const handleOpenEnquire = () => setOpenEnquire(true)
  const handleCloseEnquire = () => setOpenEnquire(false)

  useEffect(() => {
    dispatch(getBlogList())
  }, [])

  return (
    <>
      <div style={{ height: "90px", background: "#0e0e0e" }}>
        <Seo meta={meta} />
        {/* <Seo pageTitle="Invest in Royal Smart Luxury Buses I UAE" /> */}
        <Header3 />
      </div>
      <div className='investor-new'>
        <EarnInYourLocation />
        <div style={{ background: "#121212" }}>
          <DynamicHero
            tag='Be a supplier'
            className='supplier-hero'
            line1='Why Sell on'
            highlight='RSL'
            line2=''
            paragraphs={[
              'Discover a seamless and rewarding investment journey with RSL. Follow our structured process to become a valued stakeholder in one of the region’s leading luxury transportation services.'
            ]}
            image='/images/userwebsite/supplier/supplierflow.png'
            buttonText='JOIN US'
            buttonLink='/join'
            buttonClick={handleOpenEnquire}
            isSingleLine={true}
          />
        </div>
        {/* <div
          style={{
            backgroundColor: '#1E1E1E',
            padding: '40px 0px'
          }}
        >
          <section className='rsl__Wrapper_invest dynamichero-section'>
            <h1>

              <span className='highlight'>Services</span>{' '}
              we welcome
            </h1>
            <p>
              Discover a seamless and rewarding investment journey with RSL. Follow our structured process to become a valued stakeholder in one of the region’s leading luxury transportation services.
            </p>

            <SupplierSlide />
          </section>
        </div> */}

        {/* <AppDownloadSection /> */}

        <div style={{ background: "#0e0e0e" }}>
          <CommunicationChannel data={{
            sectionId: "RSLSuperApp",
            image: {
              src: "/images/bannerImage/rsl_super_app.svg",
              alt: "RSL SUPER APP"
            }
          }} />
        </div>

        <VendorRegistrationFormSupplier
          open={openEnquire}
          setOpen={setOpenEnquire}
          onClose={handleCloseEnquire}
        />
      </div>
      <FooterRSL />
    </>
  )
}
export default Supplier

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}